import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
export { SxSDeeplinkState, SxSDeeplinkStore } from './store/schema/SxSDeeplinkStore';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "SxSDeeplink"*/ './lazyIndex'));

// Delay loaded components
export const SxSDeeplink = createLazyComponent(lazyModule, m => m.SxSDeeplink);

// delay loaded public actions
export const lazySxsDeeplinkNotFound = new LazyAction(lazyModule, m => m.sxsDeeplinkNotFound);
export const lazySxsDeeplinkUnknownError = new LazyAction(
    lazyModule,
    m => m.sxsDeeplinkUnknownError
);
